import {useQuery} from 'react-query';
import {client} from './ApiClient';
import {mapServiceUrls} from '../Helpers/Functions';
import {SnippetAuth} from './SnippetAuth';

const getClubCartLine = (urls: any, auth: SnippetAuth, lineUid: string) => {
	const params = new URLSearchParams({lineUid})
	return client(urls.LoyaltyEngineApiUrl, `v5/snippets/carts/clubline?${params.toString()}`, {...auth});
}

// clubLine is undefined until loaded, then the snippet cart's line or null when there is no cart or no such line.
export default function useGetClubCartLine(urls: any, auth: SnippetAuth | undefined, lineUid: string) {
	const {status, data, error} = useQuery(['ClubCartLine', auth?.apiKey, lineUid], () => getClubCartLine(mapServiceUrls(urls), auth as SnippetAuth, lineUid), { enabled: urls && !!auth && !!lineUid, staleTime: 1000*60*60 });
	const clubLine = data ? data.data?.Line ?? null : undefined;
	return {lineStatus: status, clubLine, lineError: error};
}
